
//  * PUT      /organization/{organizationId}/automation/{automationId}/automationaction/{actionId}    (update an existing automation action)
//  * DELETE   /organization/{organizationId}/automation/{automationId}/automationaction/{actionId}    (delete an automation action)


import {  HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Projecttemplate } from '@src/app/components/org/orgprojectlist/projecttemplatecreate/model/projecttemplate';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AutomationactionService {

  constructor(private http: HttpClient) { }

    deleteAction(organizationId: string, automationId: string, actionId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete(environment.apiUrl+`/organization/${organizationId}/automation/${automationId}/automationaction/${actionId}`, httpOptions);
  }
  updateAction(organizationId: string, automationId: string, actionId: string, action: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+`/organization/${organizationId}/automation/${automationId}/automationaction/${actionId}`, action, httpOptions);
  }
  getProjectTemplates(organizationId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Projecttemplate[]>(environment.apiUrl+`/organization/${organizationId}/template/list`, httpOptions);
  }
}
